import React from "react";
import { connect } from "react-redux";
import { renderEmoji } from '../../helpers/emoji.js'
import * as clipboard from "clipboard-polyfill/text"
import { toast } from 'react-toastify';
import styled from "@emotion/styled"

class CopyEmoji extends React.PureComponent {
  render() {
    const { emoji } = this.props;
    const rendered_emoji = renderEmoji(emoji.codepoints);
    const identifier = `${emoji.name} emoji`;
    return <CopyEmojiStyle className="copy_emoji">
      <input value={rendered_emoji} readOnly/>
      {` `}
      <button className="copy button" onClick={() => {
        this.props.copy({
          date : new Date().toISOString(),
          text : rendered_emoji,
          transform: identifier
        });
        clipboard.writeText(rendered_emoji);
        toast(this.props.data.notifyCopied.string);
        (typeof window !== "undefined" && window.gtag && window.gtag("event", "copy", {
          'event_category': 'Emoji Action',
          'event_label': rendered_emoji
        }))
      }}>
        {
          this.props.lastCopy
          && rendered_emoji
          && this.props.lastCopy.transform === identifier
          ? this.props.data.copiedExclamation.string
          : this.props.data.copy.string
        }
      </button>
    </CopyEmojiStyle>
  }
}

export default connect(state => ({
  lastCopy: state.lastCopy
}), dispatch => {
  return {
		copy: (copyData) => dispatch({ type: `COPY`, copy: copyData }),
	}
})(CopyEmoji);

const CopyEmojiStyle = styled("p")`
input {
  width: 2em;
  font-size: 32px;
  text-align: center;
  background-color: #ffffff4d;
  line-height: 1.4;
  padding: 2px;
  border: 1px solid #6d6d6d;
  border-radius: 4px;
  display: inline-block;
  vertical-align: bottom;
  font-family: auto;
}
button {
	font: inherit;
	font-family: "Times New Roman";
	padding: 2px 4px;
	font-size: 16px;
  background: rgba(255, 255, 255, 0.2);
  border: 0;
  border-radius: 4px;
  cursor: pointer;
  display: inline-block;
  vertical-align: bottom;
}
button:hover {background: rgba(255, 255, 255, 0.3)}
`